export default class Navbar {
    static init(): void {
        this.navbarFixed();
        this.navbarSubmenu();
        this.navbarMobile();
        this.navbarSearch();
    }

    static navbarFixed(): void {
        const navbar = document.querySelector<HTMLElement>('.js-navbar');

        if (navbar) {
            let lastScrollTop = 0; // Uchovává poslední pozici scrollu

            window.addEventListener('scroll', () => {
                const currentScroll = window.scrollY;

                if (currentScroll === 0) {
                    // Jsme úplně nahoře - odstraníme obě třídy
                    navbar.classList.remove('navbar-not-top', 'navbar-is-fixed');
                    document.body.classList.remove('body-navbar-fixed');
                } else {
                    // Jsme mimo vrchol stránky - přidáme třídu .navbar-not-top
                    navbar.classList.add('navbar-not-top');

                    if (currentScroll > lastScrollTop) {
                        // Scrollujeme dolů - schováváme navbar
                        navbar.classList.remove('navbar-is-fixed');
                        document.body.classList.remove('body-navbar-fixed');
                    } else {
                        // Scrollujeme nahoru - zobrazujeme navbar
                        navbar.classList.add('navbar-is-fixed');
                        document.body.classList.add('body-navbar-fixed');
                    }
                }

                lastScrollTop = currentScroll; // Aktualizujeme poslední pozici scrollu
            });
        }
    }

    static navbarSubmenu(): void {
        function initializeSubmenu(): void {
            const navbar = document.querySelector('.js-navbar');
            if (!navbar) return;

            const navItems = navbar.querySelectorAll<HTMLElement>('.base-navbar__item');
            if (navItems.length === 0) return;

            let activeSubmenu: HTMLElement | null = null;
            let activeNavItem: HTMLElement | null = null;
            let currentMenuId: string | null = null;

            const clearActiveSubmenu = () => {
                if (activeSubmenu) {
                    activeSubmenu.classList.remove('is-active');
                    activeSubmenu = null;
                }
                if (activeNavItem) {
                    activeNavItem.classList.remove('is-active');
                    activeNavItem = null;
                }
                currentMenuId = null;
            };

            navItems.forEach((item) => {
                const menuId = item.dataset.menu;

                if (!menuId) return;

                item.addEventListener('mouseenter', () => {
                    if (currentMenuId !== menuId) {
                        clearActiveSubmenu();

                        const submenu = navbar.querySelector<HTMLElement>(`.base-submenu[data-submenu="${menuId}"]`);
                        if (submenu) {
                            submenu.classList.add('is-active');
                            item.classList.add('is-active');
                            activeSubmenu = submenu;
                            activeNavItem = item;
                            currentMenuId = menuId;
                            navbar.classList.add('is-submenu-active');
                        }
                    }
                });

                // Zachování submenu při pohybu mezi `nav-item` a submenu
                const submenu = navbar.querySelector<HTMLElement>(`.base-submenu[data-submenu="${menuId}"]`);
                if (submenu) {
                    submenu.addEventListener('mouseenter', () => {
                        if (currentMenuId === menuId) {
                            submenu.classList.add('is-active');
                            item.classList.add('is-active');
                        }
                    });

                    submenu.addEventListener('mouseleave', () => {
                        clearActiveSubmenu();
                        navbar.classList.remove('is-submenu-active');
                    });
                }
            });

            // Skrytí submenu při opuštění navbaru
            navbar.addEventListener('mouseleave', () => {
                clearActiveSubmenu();
            });
        }

        // Volání inicializační funkce
        initializeSubmenu();
    }

    static navbarSearch(): void {
        const searchToggle = document.querySelector<HTMLElement>('.js-navbar-search-toggle');
        const searchBox = document.querySelector<HTMLElement>('.js-navbar-search');

        if (searchToggle && searchBox) {
            searchToggle.addEventListener('click', () => {
                searchToggle.classList.toggle('is-active');
                searchBox.classList.toggle('is-active');
            });
        }
    }

    static navbarMobile(): void {
        const navbar = document.querySelector<HTMLElement>('.js-navbar');

        if (navbar) {
            const navbarMobileToggler = document.querySelector<HTMLElement>('.navbar-mobile__toggler');
            const navbarMobileMenu = document.querySelector<HTMLElement>('.navbar-mobile-menu');
            const htmlBodyTag = document.querySelector<HTMLElement>('body');
            const menuSubmenuInit = document.querySelector<HTMLElement>('.navbar-mobile-submenu');
            const menuSubmenuTrigger = document.querySelector<HTMLElement>('.js-navbar-mobile-submenu');
            const menuSubmenuCloser = document.querySelector<HTMLElement>('.navbar-mobile-back__trigger');

            // Variables for swipe detection
            let touchStartY = 0;
            let touchEndY = 0;
            const swipeThreshold = 50; // Minimum swipe distance in pixels

            if (navbarMobileToggler && navbarMobileMenu && htmlBodyTag) {
                navbarMobileToggler.addEventListener('click', () => {
                    htmlBodyTag.classList.toggle('overlay-is-active');
                    navbarMobileMenu.classList.toggle('is-active');
                    navbarMobileToggler.classList.toggle('is-active');

                    // Animate class with setTimeout
                    setTimeout(() => {
                        navbarMobileMenu.classList.toggle('is-animate');
                    }, 100);

                    if (menuSubmenuInit) {
                        menuSubmenuInit.classList.remove('is-active');
                        menuSubmenuInit.classList.remove('is-animate');
                    }
                });

                // If window is resized, remove classes
                window.addEventListener('resize', () => {
                    if (window.innerWidth > 992) {
                        htmlBodyTag.classList.remove('overlay-is-active');
                        navbarMobileMenu.classList.remove('is-active');
                        navbarMobileMenu.classList.remove('is-animate');
                        navbarMobileToggler.classList.remove('is-active');

                        if (menuSubmenuInit) {
                            menuSubmenuInit.classList.remove('is-active');
                            menuSubmenuInit.classList.remove('is-animate');
                        }
                    }
                });
            }

            if (menuSubmenuInit && menuSubmenuTrigger && menuSubmenuCloser) {
                menuSubmenuTrigger.addEventListener('click', () => {
                    menuSubmenuInit.classList.add('is-active');

                    setTimeout(() => {
                        menuSubmenuInit.classList.add('is-animate');
                    }, 100);
                });

                menuSubmenuCloser.addEventListener('click', () => {
                    menuSubmenuInit.classList.remove('is-animate');

                    setTimeout(() => {
                        menuSubmenuInit.classList.remove('is-active');
                    }, 250);
                });
            }
        }
    }
}
